<template>
  <!-- Rows with the dates (or names) in a column on the left, as in the Europass CV and the
       German Lebenslauf. Europass puts the photo on the left and tints the section bars; the
       Lebenslauf puts a passport shaped photo on the right and keeps the headings plain. -->
  <div>
    <header class="flex items-start gap-5 pb-3 border-b-2" :class="europass ? '' : 'justify-between'" :style="{ borderColor: europass ? accent : '#374151' }">
      <ResumePhoto v-if="showPicture && europass" :url="pictureUrl" :shape="settings.picture_shape" :size="84" />

      <div class="min-w-0 flex-1">
        <h1 class="text-[1.9em] font-bold leading-tight" :style="europass ? { color: accent } : null">{{ basics.full_name || 'Your name' }}</h1>
        <p v-if="basics.headline" class="mt-0.5 text-[1.05em] text-gray-700">{{ basics.headline }}</p>
        <ResumeContacts v-if="contacts.length" :contacts="contacts" stack class="mt-2 text-gray-600" />
      </div>

      <ResumePhoto v-if="showPicture && !europass" :url="pictureUrl" :shape="settings.picture_shape" :size="84" portrait />
    </header>

    <div :style="{ display: 'flex', flexDirection: 'column', gap: `${gap}px`, marginTop: `${gap}px` }">
      <section v-for="section in sections" :key="section.id" class="resume-section">
        <h2 class="mb-2 text-[0.88em] font-bold uppercase tracking-[0.1em]"
          :class="europass ? 'px-2 py-1 rounded-sm' : 'pb-1 border-b border-gray-300 text-gray-900'"
          :style="europass ? { color: accent, backgroundColor: `${accent}1a` } : null">{{ section.title }}</h2>
        <ResumeSection :section="section" :content="content" :accent="accent" :layout="section.key === 'summary' ? 'default' : 'tabular'" />
      </section>
    </div>

    <p v-if="!sections.length && !basics.full_name" class="mt-10 text-center text-gray-400">Your resume appears here as you type.</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import ResumeContacts from './ResumeContacts.vue'
import ResumePhoto from './ResumePhoto.vue'
import ResumeSection from './ResumeSection.vue'
import { gapOf } from './resumeLayout.js'
import { useResumeView } from './resumeView.js'

const props = defineProps({
  content: { type: Object, required: true },
  template: { type: String, default: 'europass' },
  pictureUrl: { type: String, default: null },
})

const { basics, settings, accent, contacts, sections, showPicture } = useResumeView(props)
const europass = computed(() => props.template === 'europass')
const gap = computed(() => gapOf(settings.value))
</script>
